module.exports = "<div class=row id=admin-politics-detail> <div class=col-xs-12> <div class=page-header> <h1><a ng-href=/admin/politics>Politics</a> / Add Politic</h1> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./client/src/app/admin/politics/admin-politics-add.tpl.html
// module id = 254
// module chunks = 2